import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/common/SEO';
import StudioHome from '../components/home/StudioHome';
import { pageMetadata, structuredDataTemplates } from '../utils/seo-config';

const Home = () => {
  const { t, i18n } = useTranslation('studio');
  const pageUrl = i18n.language?.startsWith('es') ? 'https://jamaklab.com/es' : 'https://jamaklab.com/';
  // Organization, WebSite and ProfessionalService JSON-LD live statically in
  // index.html so non-JS crawlers see them; only add the page-specific
  // breadcrumb here.
  const structuredData = [
    structuredDataTemplates.breadcrumb([
      { name: 'Home', url: 'https://jamaklab.com/' }
    ])
  ];

  return (
    <>
      <SEO
        title={t('meta.title')}
        description={t('meta.description')}
        keywords={pageMetadata.home.keywords}
        image={i18n.language?.startsWith('es') ? 'https://jamaklab.com/images/og/og-image-es.png?v=r01' : pageMetadata.home.image}
        url={pageUrl}
        structuredData={structuredData}
      />
      <StudioHome />
    </>
  );
};

export default Home;
